import { ACCOUNT } from 'account/constants/entities';
import { entityEndpointMap } from 'base/constants/endpoints';
import { apiAction } from 'base/utils/apiHelpers';
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  BOOTSTRAP
} from 'base/actions/actionTypes';

export function fetchAccount() {
  const baseEndpoint = entityEndpointMap[ACCOUNT];
  const endpoint = `${baseEndpoint}`;
  const types = [
    { type: `[${ACCOUNT}] ${FETCH_REQUEST}` },
    {
      type: `[${ACCOUNT}] ${FETCH_SUCCESS}`,
      meta: { lastFetched: Date.now() }
    },
    { type: `[${ACCOUNT}] ${FETCH_FAILURE}` }
  ];

  return apiAction(endpoint, 'GET', types);
}

export function bootStrapAccount() {
  return {
    type: `[${ACCOUNT}] ${BOOTSTRAP}`,
    payload: window.bentoboxOnlineOrdering.account,
    meta: { lastFetched: Date.now() }
  };
}
